import type { ChangeEvent } from "react";
import { Button, Form, Input, Tooltip } from "antd";
import { ThunderboltOutlined } from "@ant-design/icons";
import { useLessonForm } from "./LessonFormContext";

const { TextArea } = Input;

const LessonMetaFields: React.FC = () => {
  const {
    lesson, setLesson,
    isGeneratingLessonSummary,
    handleGenerateLessonSummary,
  } = useLessonForm();

  return (
    <>
      <Form.Item
        label="Título de la Lección"
        rules={[{ required: true, message: "El título es obligatorio" }]}
        className="lesson-title"
        validateStatus={lesson.title.trim() ? "success" : "error"}
        help={lesson.title.trim() ? null : "El título es obligatorio"}
      >
        <Input
          placeholder="Título de la lección"
          value={lesson.title}
          onChange={(e: ChangeEvent<HTMLInputElement>) =>
            setLesson({ ...lesson, title: e.target.value })
          }
        />
      </Form.Item>

      <Form.Item label="Objetivo de la Lección" className="lesson-objective">
        <Input.TextArea
          placeholder="Describe el objetivo principal de esta lección..."
          value={lesson.objectives_lesson || ""}
          onChange={(e: ChangeEvent<HTMLTextAreaElement>) =>
            setLesson({ ...lesson, objectives_lesson: e.target.value })
          }
          rows={3}
        />
      </Form.Item>

      <Form.Item label="Resumen de lección" className="lesson-summary">
        <div style={{ display: "flex", gap: "8px", alignItems: "flex-start" }}>
          <TextArea
            placeholder="Resumen breve de la lección..."
            value={lesson.summary || ""}
            onChange={(e: ChangeEvent<HTMLTextAreaElement>) =>
              setLesson({ ...lesson, summary: e.target.value })
            }
            rows={3}
            style={{ flex: 1 }}
          />
          <Tooltip title="Generar resumen con IA">
            <Button
              type="primary"
              icon={<ThunderboltOutlined />}
              loading={isGeneratingLessonSummary}
              onClick={handleGenerateLessonSummary}
              style={{ minWidth: "40px" }}
            >
              {isGeneratingLessonSummary ? "" : "IA"}
            </Button>
          </Tooltip>
        </div>
      </Form.Item>

      <Form.Item
        label="Contribución al Producto Final (sólo se muestra en Proyectos)"
        className="lesson-contribution"
        tooltip="Solo aplica cuando la lección pertenece a un proyecto. En cursos normales este campo no se muestra a los alumnos."
      >
        <Input.TextArea
          placeholder="Describe cómo esta lección contribuye al producto final del proyecto..."
          value={lesson.final_product_contribution || ""}
          onChange={(e: ChangeEvent<HTMLTextAreaElement>) =>
            setLesson({ ...lesson, final_product_contribution: e.target.value })
          }
          rows={3}
        />
      </Form.Item>
    </>
  );
};

export default LessonMetaFields;
